<template>
  <el-dialog
    :visible="dialogVisible"
    width="500px"
    :before-close="close"
    :close-on-click-modal="false"
    class="customDialogForm"
    :title="title"
  >
    <el-form ref="customerform" :rules="rules" :model="customer">
      <el-form-item prop="customerName" label="名称" :label-width="formLabelWidth">
        <el-input v-model="customer.customerName" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item prop="contactName" label="联系人" :label-width="formLabelWidth">
        <el-input v-model="customer.contactName" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item prop="contactPhone" label="联系电话" :label-width="formLabelWidth">
        <el-input v-model="customer.contactPhone" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="负责组织" :label-width="formLabelWidth">
        <el-select @change="this.fetchOrgUser" v-model="customer.headOrg" placeholder="选择负责组织">
          <el-option
            v-for="item in myorgs"
            :key="item.orgID"
            :label="item.name"
            :value="item.orgID"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="负责人" :label-width="formLabelWidth">
        <el-select v-model="customer.headUser" placeholder="选择负责人">
          <el-option
            v-for="item in orgUsers"
            :key="item.userID"
            :label="item.realName || item.username"
            :value="item.userID"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="submit" :loading="Loading">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { updateCustomer, createCustomer } from '@/api/customer';
import { getAllUserListApi } from '@/api/enterpriseManage';
import { errorHandle } from '@/utils/error';
export default {
  name: 'EditCustomer',
  props: {
    customer: {
      type: Object,
      default: () => {
        return {
          customerName: '',
          contactName: '',
          contactPhone: '',
          headOrg: '',
          headUser: ''
        };
      }
    },
    appID: String,
    marketID: String,
    dialogVisible: Boolean,
    onClose: Function,
    onSuccess: Function
  },
  data() {
    return {
      rules: {
        customerName: [
          { required: true, message: '请填写客户名称', trigger: 'blur' },
          {
            min: 2,
            max: 255,
            message: '客户名称最小两个字符，不能超过255字符',
            trigger: 'blur'
          }
        ],
        contactName: [
          { max: 255, message: '客户联系人不能超过255字符', trigger: 'blur' }
        ],
        contactPhone: [
          { min: 7, message: '客户联系电话不合法', trigger: 'blur' },
          { max: 11, message: '客户联系电话不能超过11字符', trigger: 'blur' }
        ],
        headOrg: [
          { max: 255, message: '负责组织不能超过255字符', trigger: 'blur' }
        ],
        headUser: [
          { max: 255, message: '负责人不能超过255个字符', trigger: 'blur' }
        ]
      },
      app: {},
      title: this.customer.customerID ? '编辑客户信息' : '添加客户',
      formLabelWidth: '80px',
      Loading: false,
      orgUsers: []
    };
  },
  created() {},
  computed: {
    myorgs() {
      return this.$store.state.user.userOrgs;
    },
    eid() {
      return this.$store.state.user.userInfo.eid;
    }
  },
  methods: {
    fetchOrgUser(orgID) {
      this.orgUsers = []
      getAllUserListApi({
        eid: this.eid,
        orgID: orgID,
        page: -1,
        pageSize: -1
      })
        .then(res => {
          if (res.users && res.users.length > 0) {
            this.orgUsers = res.users;
            this.customer.headUser = res.users[0].userID;
          }
        })
        .catch(err => {
          errorHandle(err);
        });
    },
    submit() {
      this.Loading = true;
      this.$refs.customerform.validate(valid => {
        if (valid) {
          if (this.customer.customerID) {
            updateCustomer(this.customer)
              .then(res => {
                this.Loading = false;
                this.$message.success('更新成功')
                this.onSuccess && this.onSuccess();
              })
              .catch(err => {
                this.Loading = false;
                errorHandle(err);
              });
          } else {
            this.customer.marketID = this.marketID;
            createCustomer(this.customer)
              .then(res => {
                this.Loading = false;
                this.$message.success('添加成功')
                this.onSuccess && this.onSuccess();
              })
              .catch(err => {
                this.Loading = false;
                errorHandle(err);
              });
          }
        } else {
          this.Loading = false;
        }
      });
    },
    close() {
      this.$refs.customerform.resetFields();
      this.onClose && this.onClose();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/customerManage/components/editCustomer.vue